module.exports = __webpack_public_path__ + "static/media/workday.303d68b9.jpg";